"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetEnvironmentScreensAttiributeConditionAttribute = exports.ContentsMediaType = void 0;
/**
 * Content types found in Contents Media S3 bucket.
 * Also supported by html2image lambda function
 */
var ContentsMediaType;
(function (ContentsMediaType) {
    ContentsMediaType["infopages"] = "infopages";
    ContentsMediaType["screens"] = "screens";
    ContentsMediaType["contents"] = "contents";
    ContentsMediaType["lists"] = "lists";
    ContentsMediaType["templates"] = "templates";
})(ContentsMediaType = exports.ContentsMediaType || (exports.ContentsMediaType = {}));
var GetEnvironmentScreensAttiributeConditionAttribute;
(function (GetEnvironmentScreensAttiributeConditionAttribute) {
    GetEnvironmentScreensAttiributeConditionAttribute["locationId"] = "locationId";
    GetEnvironmentScreensAttiributeConditionAttribute["billable"] = "billable";
})(GetEnvironmentScreensAttiributeConditionAttribute = exports.GetEnvironmentScreensAttiributeConditionAttribute || (exports.GetEnvironmentScreensAttiributeConditionAttribute = {}));
//# sourceMappingURL=lambda.js.map